<coin-html-editor
  [showAdditionalEditOptions]="showAdditionalEditOptions"
  [contentEdit]="true"
  [item]="$any(item)"></coin-html-editor>
